<style>


</style>




<mat-sidenav-container fullscreen>
  <!-- (click)="sidenav.toggle()" -->
  <mat-sidenav
    #sidenav
    role="navigation"
    mode="over"
    position="start"
    class="navbar-bg"
   
  >
    <app-sidenav (sidenavToggle)="sidenav.toggle()"></app-sidenav>
  </mat-sidenav>

  <mat-sidenav-content  style="    overflow-x: hidden !important;">
    <app-navbar
      [casino_page]="casino_page"
      fxHide
      fxShow.lt-sm
      
      (sidenavToggle)="sidenav.toggle()"
    ></app-navbar>
    <!--    <app-home></app-home>-->
    <main
      class="container-fluid mat-app-background bg-container zero-margin-desktop margin-mobile"
    >
      <div class="container-fluid p-0">
          
          
        <div class="">
          <div class="row m-0 col-12 col-md-12 col-lg-12 col-sm-12 p-0">
             

<div
              *ngIf="!fullview"
              [class.col-md-3]="!casino_sidebar_visible"
              style="overflow-y: auto;     overflow-y: auto;
    display: flex !important
;
    width: 100%;"
              [class.col-md-2]="casino_sidebar_visible"
              class="m-0 p-0 col-md-block col-lg-block d-sm-block d-none"
            >
              <div *ngIf="!casino_sidebar_visible">
                <h5 class="text-light">
                  <div class="ballby ml-1" style="display:none;">
                    <div
                      class="material-symbols-outlined"
                      style="vertical-align: middle; line-height: 50px"
                    >
                      info
                    </div>
                  </div>
                </h5>
                <div *ngIf="betslip_visible">
                  <div
                    style="position: absolute; right: 10px; cursor: pointer"
                    (click)="closeBet()"
                    class="text-light h3"
                  >
                    &times;
                  </div>
                  <app-betslipplain [data]="betdata"> </app-betslipplain>
                </div>
                <div *ngIf="casino_betslip_visible">
                  <div
                    style="position: absolute; right: 10px; cursor: pointer"
                    (click)="closeCasinoBet()"
                    class="text-light h3"
                  >
                    &times;
                  </div>
                  <app-casino-bet-slip-plain [data]="betdata">
                  </app-casino-bet-slip-plain>
                </div>
              </div>
            </div>

            <div
              [class.col-md-7]="!casino_sidebar_visible && !fullview"
              [class.col-md-8]="casino_sidebar_visible && !fullview"
              [class.col-md-12]="fullview"
              class=" m-0 p-0" 
              style="width: 100% !important;"
            >
              <router-outlet></router-outlet>
              
            </div>
          </div>
        </div>
      </div>

      <footer class="py-3 my-4 bg-dark">
        <ul class="nav justify-content-center pb-3 mb-3">
            <li class="nav-item"><a href="#"
                    class="nav-link px-2 text-link"
                    routerLink="/dashboard/contactus">Contact
                    Us</a></li>
            <li class="nav-item"><a href="#"
                    class="nav-link px-2 text-link"
                    routerLink="/dashboard/privacypolicy">Privacy
                    Policy</a></li>
            <li class="nav-item"><a href="#"
                    class="nav-link px-2 text-link"
                    routerLink="/dashboard/gamesrule">Game
                    Rules</a></li>
            <li class="nav-item"><a href="#"
                    class="nav-link px-2 text-link"
                    routerLink="/dashboard/terms">Terms
                    and Conditions</a></li>
        </ul>
    </footer>
      
    </main>
       <button class="btn fixed-button2 p-0" (click)="openDialog()"><img style="width: 60px;"
                                                                    src="/assets/icons/chat-icon-white.png"/>
   </button>
    <app-footer class="sticky-bottom" style="">
    </app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
